import { getDSHocSinh, getDSHocSinhThuBay, getDSHocSinhDangKyThuBay } from '@/services/HocSinh/hocsinh';
import { getQuanLyLop } from '@/services/QuanLyLop/quanlylop';
import type { QuanLyLop } from '@/services/QuanLyLop';
import { useState } from 'react';
import type { HocSinh } from '@/services/HocSinh';
import axios from 'axios';
import { useModel } from 'umi';
import moment from 'moment';

export default () => {
  const [danhSach, setDanhSach] = useState<HocSinh.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<QuanLyLop.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});

  const { initialState } = useModel('@@initialState');
  const parent = initialState?.currentUser?.role?.organizationId;
  const vaiTro = localStorage.getItem('vaiTro');

  const getDSHocSinhModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getDSHocSinh({ page, limit, cond, donViId });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getDSHocSinhThuBayModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getDSHocSinhThuBay({
      page, 
      limit, 
      cond: {
        ...cond,
        thang: cond?.thang ?? moment().month(),
        nam: cond?.nam ?? moment().year(),
      } , 
      donViId});
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  }
  const getDSHocSinhDangKyThuBayModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getDSHocSinhDangKyThuBay({page, limit, cond: {...cond}});
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  }
  const getQuanLyLopModel = async (parentId: string) => {
    setLoading(true);
    const response = await getQuanLyLop({ page, limit, cond, parent: parentId || parent, vaiTro });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total ?? 0);
    setLoading(false);
  };

  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getDSHocSinhModel,
    getDSHocSinhThuBayModel,
    getDSHocSinhDangKyThuBayModel,
    getQuanLyLopModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
  };
};
